import { KazooError } from "@kazoohr/types";

export function replaceUntilDone(
  regex: RegExp,
  input: string,
  replacement: string,
  limit: number = 1000
) {
  let i = 0;
  // while we could mutate the argument, some linters consider this bad form.
  let returnValue = input;
  while (returnValue.match(regex)) {
    returnValue = returnValue.replace(regex, replacement);
    i++;
    if (i > limit) {
      throw new KazooError("Infinite loop detected", {
        regex,
        input,
        limit,
        times: i,
      });
    }
  }
  return returnValue;
}
